import { useEffect, useState } from "react";
import { api } from "./api";

// Branches for the staff app. The picked branch is sent on every API call (X-Branch) by lib/api.js.
let cache = null;
let inflight = null;
const subs = new Set();

export function loadBranches(force = false) {
  if (!force && cache) return Promise.resolve(cache);
  if (!force && inflight) return inflight;
  inflight = api.get("/branches").then(({ data }) => { cache = data; subs.forEach((f) => f(data)); return data; })
    .catch(() => null).finally(() => { inflight = null; });
  return inflight;
}

export function useBranches() {
  const [data, setData] = useState(cache);
  useEffect(() => {
    subs.add(setData);
    loadBranches();
    return () => { subs.delete(setData); };
  }, []);
  const multi = data?.mode === "multiple";
  const active = (data?.items || []).filter((b) => b.active);
  return { data, multi, branches: active, all: data?.items || [], seesAll: !!data?.sees_all, reload: () => loadBranches(true) };
}

export const branchName = (b, lang) => {
  if (!b) return "";
  if (lang === "ar" && b.name_ar) return b.name_ar;
  const name = b.name || "";
  return b.city && !name.toLowerCase().includes(b.city.toLowerCase()) ? `${name} – ${b.city}` : name;
};

export const pickedBranch = () => localStorage.getItem("branch") || "";
export function pickBranch(id) {
  if (id) localStorage.setItem("branch", id); else localStorage.removeItem("branch");
  window.dispatchEvent(new Event("branch-change"));
}

export function usePickedBranch() {
  const [b, setB] = useState(pickedBranch());
  useEffect(() => {
    const f = () => setB(pickedBranch());
    window.addEventListener("branch-change", f);
    return () => window.removeEventListener("branch-change", f);
  }, []);
  return b;
}
